import   React              from "react";

import   classNames         from "classnames";

import   styles              from "./PurchaseHistory.module.scss";

import   PaymentList         from "../paymentManagment/PaymentList";

import { useTypedSelector  } from "../../../store/useTypeSelector";
import { RootState         } from "../../../store/generalReducer";

export interface PurchaseHistoryProps {
  email?: string;
  // Sans elle, PaymentList retombe sur "depuis hier" (cf. son propre fallback) : les
  // achats plus anciens que la veille restent invisibles. On la transmet donc pour
  // remonter jusqu'à la création du compte, comme prévu par ce prop de PaymentList.
  creationDate?: Date | null;
}

// Historique d'achats du créateur : simple habillage de PaymentList (déjà utilisé,
// scopé, comme onglet "Commande" dans UserList) — scopé sur `email` s'il est fourni
// (fiche d'un créateur ouverte par un superadmin), sinon sur le compte connecté.
export const PurchaseHistory: React.FC<PurchaseHistoryProps> = ({ email: emailProp, creationDate: creationDateProp }) => {

  const { authentication } = useTypedSelector((state: RootState) => state.authenticationReducer);

  const email             = emailProp        ?? authentication.admin?.email;
  const rawCreationDate   = creationDateProp ?? authentication.admin?.creationDate;
  // Certains comptes historiques portent un zéro-date MySQL ("0000-00-00 00:00:00") :
  // truthy côté transformAdmin (pas null), mais `new Date(...)` en fait un Invalid
  // Date qui plante plus bas (DateTimeRangePicker) sans ce garde-fou — même contrôle
  // que formatDateOrDash.
  const creationDate      = rawCreationDate && !isNaN(rawCreationDate.getTime()) ? rawCreationDate : undefined;

  if (!email) {
    return (
      <div className={classNames(styles.root)}>
        Chargement du profil...
      </div>
    );
  }

  return (
    <div className={classNames(styles.root)}>
      <PaymentList userEmail={email} userCreationDate={creationDate} />
    </div>
  );
};

export default PurchaseHistory;
